/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_NextInputs */

const bn_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরবর্তী`)
};

const de_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste`)
};

const el_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επόμενος`)
};

const en_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const es_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo`)
};

const fr_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivant`)
};

const hi_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगला`)
};

const hu_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Következő`)
};

const id_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berikutnya`)
};

const it_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimo`)
};

const ja_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次`)
};

const ko_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음`)
};

const nl_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volgende`)
};

const pl_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następny`)
};

const pt_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo`)
};

const ru_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следующий`)
};

const sv_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nästa`)
};

const tr_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonraki`)
};

const uk_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Далі`)
};

const vi_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kế tiếp`)
};

const zh_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一个`)
};

const zh_hant_action_next = /** @type {(inputs: Action_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一個`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Action_NextInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const action_next = /** @type {((inputs?: Action_NextInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_NextInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_action_next(inputs)
	if (locale === "de") return de_action_next(inputs)
	if (locale === "el") return el_action_next(inputs)
	if (locale === "en") return en_action_next(inputs)
	if (locale === "es") return es_action_next(inputs)
	if (locale === "fr") return fr_action_next(inputs)
	if (locale === "hi") return hi_action_next(inputs)
	if (locale === "hu") return hu_action_next(inputs)
	if (locale === "id") return id_action_next(inputs)
	if (locale === "it") return it_action_next(inputs)
	if (locale === "ja") return ja_action_next(inputs)
	if (locale === "ko") return ko_action_next(inputs)
	if (locale === "nl") return nl_action_next(inputs)
	if (locale === "pl") return pl_action_next(inputs)
	if (locale === "pt") return pt_action_next(inputs)
	if (locale === "ru") return ru_action_next(inputs)
	if (locale === "sv") return sv_action_next(inputs)
	if (locale === "tr") return tr_action_next(inputs)
	if (locale === "uk") return uk_action_next(inputs)
	if (locale === "vi") return vi_action_next(inputs)
	if (locale === "zh") return zh_action_next(inputs)
	return zh_hant_action_next(inputs)
});